import ChartFauxMarche from "./ChartFauxMarche";

export default function Page() {
  return (
    <ChartFauxMarche
    config={{
    crashWindows: [
      ["30/09/2025 17:10:00", "30/09/2025 17:15:00"],
      ["30/09/2025 17:20:00", "30/09/2025 17:25:00"],
      ["30/09/2025 17:30:00", "30/09/2025 17:35:00"],
      ["30/09/2025 17:40:00", "30/09/2025 17:45:00"],
    ],

    randMin: 1,
    randMax: 30,
    barMs: 1000,
  }}
/>
  );
}